import React from 'react';
import { Col, Form } from 'antd';

import { useApplicationContext } from '@/context/v1/Application/context';
import { CompanySelect } from '@/components/ui/Inputs/CompanySelect';
import { useListCompanies } from '@/hooks/v1/useListCompanies';
import FormItem from '@/components/ui/FormItem';

const { useFormInstance, useWatch } = Form;

interface CompaniesProps {
	disabled?: boolean;
}

export function Companies({ disabled = false }: Readonly<CompaniesProps>): JSX.Element {
	const form = useFormInstance();
	const { setFieldValue } = useFormInstance();
	const { organization, company } = useApplicationContext();

	const companyId = useWatch('company_id', form);
	const {
		data: companies,
		isLoading,
		isFetching,
		isError
	} = useListCompanies({
		organization_id: organization?.id,
		company_id: company?.id
	});

	function handleCompanySelect(id: string) {
		setFieldValue(['company_id'], id);
		form.setFieldValue(['sector_id'], undefined);
		form.setFieldValue(['line_id'], undefined);
		form.setFieldValue(['workstation_id'], undefined);
	}

	function handleClearCompany() {
		setFieldValue(['company_id'], undefined);
		form.setFieldValue(['sector_id'], undefined);
		form.setFieldValue(['line_id'], undefined);
		form.setFieldValue(['workstation_id'], undefined);
	}

	return (
		<Col xs={24} sm={12}>
			<FormItem
				name={['company_id']}
				label="Industrial site"
				labelCol={{ span: 24 }}
				requiredMessage="Select the industrial site"
				required
			>
				<CompanySelect
					size="large"
					companies={companies}
					loading={isFetching}
					disabled={disabled || isLoading || isFetching || isError}
					companyId={companyId}
					handleClearCompany={handleClearCompany}
					handleSelectCompany={handleCompanySelect}
				/>
			</FormItem>
		</Col>
	);
}
